import { RootState } from "../../../store";
import {IUser} from "../../../models/IUser";
import { createSelector } from "@reduxjs/toolkit";

const selectUsersState = (state: RootState) => state.users;

export const selectCurrentUser = createSelector([selectUsersState], (usersState) => usersState.current);

export const selectCurrentUserId = createSelector([selectUsersState], (usersState) => usersState.current?.id);

export const selectUsersFromOptions = createSelector([selectUsersState], (usersState) =>
  usersState.list.map((user) => ({ id: user.id, title: `${user.first_name} ${user.last_name}` })),
);

export const selectIsUsersLoading = createSelector([selectUsersState], (usersState) => usersState.isLoading);

export const selectUserById = createSelector(
  [selectUsersState, (_: any, userId: string | number) => userId],
  (usersState, userId) => usersState.list.find((user: IUser) => user.id === userId),
);

export const selectAllUsers = createSelector(
    [selectUsersState],
    (usersState): IUser[] => {
      const FIRED_STATUS_ID = 4;

      const compareByName = (a: IUser, b: IUser) => {
        const byFirst = (a.first_name ?? "").localeCompare(b.first_name ?? "", "ru");
        if (byFirst !== 0) return byFirst;
        return (a.last_name ?? "").localeCompare(b.last_name ?? "", "ru");
      };

      const active: IUser[] = [];
      const fired: IUser[] = [];
      for (const user of usersState.list) {
        if (user.status_id === FIRED_STATUS_ID) fired.push(user);
        else active.push(user);
      }
      active.sort(compareByName);
      fired.sort(compareByName);

      return [...active, ...fired];
    },
);

export const getUserById = (state: RootState, useId: string): IUser => {
  return state.users.list.filter((user: IUser) => user.id === useId)[0];
};

export const getUserFullNameById = (state: RootState, userId: string): string => {
  return "asd";
};

/**
 * Права у всех одинаковые (решение владельца 24.10): сотрудниками и
 * получателями MAX управляет любой вошедший — так же решает бэкенд
 * (UserService, CompanyService).
 */
export const selectIsDirector = createSelector(
    [selectCurrentUser],
    (currentUser) => Boolean(currentUser),
);

